import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import GaiaConfirmActionDialog from "~/modules/app/components/GaiaConfirmActionDialog";
import useDestructiveActionBlocker from "~/modules/app/hooks/useDestructiveActionBlocker";

import { ProjectReviewVisitV2OverviewPanel } from "../../components/ProjectReviewVisitV2OverviewPanel";
import { ProjectReviewVisitV2OverviewPanelSkeleton } from "../../components/ProjectReviewVisitV2OverviewPanel/skeleton";
import { useReviewVisitDecisionActions } from "../../hooks/useReviewVisitDecisionActions";
import { ProjectReviewVisitV2OverviewRoute_GetDataDocument } from "./queries.generated";
import { useProjectReviewVisitV2OverviewRoute_GetData } from "./useProjectReviewVisitV2OverviewRoute_GetData";

export function ProjectReviewVisitV2OverviewRoute() {
    const { t } = useTranslation("project");
    const { clientSlug, projectSlug, visitId } = useParams();
    if (!clientSlug || !projectSlug || !visitId) throw new Error("invalid params");

    const { visit, panelStatus, loading, isEverythingReady } = useProjectReviewVisitV2OverviewRoute_GetData(visitId);

    const { handleApprove, loading: decisionsLoading } = useReviewVisitDecisionActions({
        visitId,
        refetchQueries: [ProjectReviewVisitV2OverviewRoute_GetDataDocument],
    });

    const approveBlocker = useDestructiveActionBlocker(async () => {
        await handleApprove();
    });

    return loading ? (
        <ProjectReviewVisitV2OverviewPanelSkeleton />
    ) : (
        visit && (
            <>
                <ProjectReviewVisitV2OverviewPanel
                    visit={visit}
                    onApprove={async () => approveBlocker.onAction()}
                    loading={decisionsLoading}
                    panelStatus={panelStatus}
                    isEverythingReady={isEverythingReady}
                    showFinalReportButton={true}
                />
                <GaiaConfirmActionDialog
                    title={t("projectReviewVisitV2.overview.approveDialog.title")}
                    description={t("projectReviewVisitV2.overview.approveDialog.description")}
                    blocker={approveBlocker}
                />
            </>
        )
    );
}
